import { styled } from 'linaria/lib/react';
import { COLORS, FONTS } from 'styles/constants';
import noiseTexture from 'assets/images/noise.png';

export const StyledGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 56px;
  position: relative;
  padding-bottom: 140px;
`;

export const StyledListItem = styled.div`
  position: relative;
  z-index: 1;
`;

export const StyledFirstListItem = styled(StyledListItem)`
  padding-top: 0;
`;

export const StyledGradientOverlay = styled.div<{ isMyProfile: boolean; isDark: boolean; gradientStartColor: string }>`
  position: absolute;
  top: 0;
  bottom: 0;
  left: calc(50% - 50vw);
  width: 100vw;
  pointer-events: none;
  z-index: -1;
  background: ${({ gradientStartColor, isDark }) =>
    `linear-gradient(180deg, ${gradientStartColor} 0%, ${isDark ? COLORS.black[100] : COLORS.white[100]} 100%)`};

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url(${noiseTexture}),
      ${({ gradientStartColor, isDark, isMyProfile }) => {
        const topStop = isMyProfile === false ? '20%' : '5%';
        return `linear-gradient(180deg, ${gradientStartColor} ${topStop}, ${gradientStartColor} 65%, ${
          isDark ? COLORS.black[100] : COLORS.white[100]
        } 100%)`;
      }};
    background-repeat: repeat;
    background-size: auto;
    background-position: 0 0;
    -webkit-mask-image: ${({ isMyProfile }) =>
      `linear-gradient(180deg, rgba(0, 0, 0, 1) ${isMyProfile === false ? '20%' : '5%'}, rgba(0, 0, 0, 0) 100%)`};
    mask-image: ${({ isMyProfile }) =>
      `linear-gradient(180deg, rgba(0, 0, 0, 1) ${isMyProfile === false ? '20%' : '5%'}, rgba(0, 0, 0, 0) 100%)`};
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-size: 100% 100%;
    mask-size: 100% 100%;
    pointer-events: none;
  }
`;

export const StyledListItemInner = styled.div`
  position: relative;
  z-index: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const StyledListItemHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 12px;
  gap: 12px;
`;

export const StyledOwnerRow = styled.div<{ showReactionButton?: boolean }>`
  display: flex;
  padding: 0 12px 12px 12px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  position: relative;
`;

export const StyledReactionButtonWrapper = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
`;

export const StyledOwnerAvatar = styled.div`
  display: flex;
  width: 20px;
  height: 20px;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 50%;
`;

export const StyledOwnerDescription = styled.p`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  flex: 1 0 0;
  font: 600 14px/140% ${FONTS.secondary};
  margin: 0;
  color: inherit;
  overflow: hidden;
`;

export const StyledListActions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  padding: 0 12px 12px 0;
  margin-top: 12px;
`;
